/**
 * 配車計画 最終更新
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/last_updates`

 const allocate_entry_last_update = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { target_date }) {
      const params = { target_date: target_date }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          // let content = data.content
          // commit(types.DRIVER_DISPOSER, { content })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_last_update
